/**
 * L'Invoice project translations - Pages section
 */

const pages = {
  documents: {
    title: "Documents",
    subtitle: "Simplify your financial documentation with our ready-made templates. Choose a template, input your data, and generate your document in seconds.",
  },
  edocuments: {
    title: "E-Documents",
    subtitle: "Simplify your financial documentation with our ready-made templates. Choose template, input your data, and generate your document in seconds.",
  },
  customers: {
    title: "Customers",
    subtitle: "On this page, you will find all your customers.",
  },
  settings: {
    title: "Settings",
  },
  lookUp: {
    title: "Look Up",
    helperText: "Enter the name, address, ID or any other keyword of the entity you are looking for.",
  },
  create: {
    title: "Create",
    createVatInvoice: "Create VAT Invoice",
    createSalesTaxInvoice: "Create Sales Tax Invoice",
    createCreditNote: "Create Credit Note",
    editVatInvoice: "Edit VAT Invoice",
    editSalesTaxInvoice: "Edit Sales Tax Invoice",
    editCreditNote: "Edit Credit Note",
  },
};

export default pages;
